import { inject, Injectable } from "@angular/core";

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { TokenService } from "../../services/tokenservice";
import { SurfExceptionHandler } from "../surfexceptionhandler";
import { Router } from "@angular/router";
import { ErrorRouter } from "./error-router";

@Injectable()
export class NWDHttpInterceptor implements HttpInterceptor {
  private errorRouter = inject(ErrorRouter);

  constructor(
    private token: TokenService,
    private seh: SurfExceptionHandler,
    private router: Router,
  ) {}

  private excludedPages = ["/forbidden", "/error", "/notfound", "/support", "/news"];

  isNonRoutable(url: string): boolean {
    return this.excludedPages.map((p) => url.indexOf(p) === -1).filter((b) => !b).length > 0;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only add Authorization header here if not already present
    if (!request.headers.has("Authorization")) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token.httpToken()}`,
        },
      });
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // do stuff with response if you want
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (request.headers.get("x-ignore-interceptor") === "1") {
              return;
            }
            const page = this.router.routerState.snapshot.url;

            if (this.isNonRoutable(request.url) || this.isNonRoutable(page)) {
              return;
            }

            this.errorRouter.redirect(request.url, err.status);
          }
        },
      ),
    );
  }
}
